export default {
  loading: false,
  loadingProgress: 0,
};
